module.exports = __webpack_public_path__ + "static/media/18ECA14.db753484.jpg";